import { useFlag } from "../../config/featureFlags";
import { recordAnalyticsEvent } from "../../analytics";
import { Button } from "../../components/util";
import { Header, Section } from "../../components/layout";
import { OnboardingNewBroker } from "../../components/content";
import ClientList from "./clientList";

import * as Styled from "./styles.css";
import { urls } from "../../config/appConfig";

const Portfolio = () => {
  const handleQuoteClick = () => {
    recordAnalyticsEvent("action", "Create Quote", {
      path: urls.salesforceNewQuoteUrl,
    });
  };

  return (
    <Styled.Grid $fullHeight>
      <Header
        actions={
          useFlag("portal.quotebutton") && (
            <Button
              color="accent"
              href={urls.salesforceNewQuoteUrl}
              isNewTab
              onClick={() => handleQuoteClick()}
              variant="contained"
            >
              Create quote
            </Button>
          )
        }
        title="Portfolio"
        type="article"
      ></Header>
      <Section>
        {/* <OnboardingNewBroker /> This panel doesn't seem to do anything */}
        <ClientList />
      </Section>
    </Styled.Grid>
  );
};
export default Portfolio;
